import React, { FC } from 'react';
import cx from 'classnames';

import { LoadingArrow } from 'Storybook/components/local/LoadingArrow/LoadingArrow';

import styles from './Loader.scss';

type LoaderProps = {
  className?: string;
  text?: string;
};

const Loader: FC<LoaderProps> = ({ className = '', text }) => (
  <div className={cx(styles.loader, className)} data-testid="loader">
    <LoadingArrow showText={!!text} size="large" text={text} />
  </div>
);

export default Loader;
